module.exports = __webpack_public_path__ + "img/na.d1ebb4bd.svg";